import script from "./navcon.vue?vue&type=script&setup=true&lang=js"
export * from "./navcon.vue?vue&type=script&setup=true&lang=js"

import "./navcon.vue?vue&type=style&index=0&id=4c954a48&lang=scss&scoped=true"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c954a48"]])

export default __exports__